/**
 * @packageDocumentation
 * @module f1/is
 */

import uppercase from '../str/uppercase';

export interface IsUppercase {
  /**
   * Are all characters uppercase, if part of the alphabet
   *
   * @public
   * @function f1.is.uppercase
   * @example
   *
   * ```ts
   * f1.is.uppercase('hi') => false
   * f1.is.uppercase('Hi') => false
   * f1.is.uppercase('HI') => true
   * ```
   */
  (value: string): boolean;
}

/**
 * @see IsUppercase
 */
export default (str: string): boolean => {
  return str === uppercase(str);
};
